import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface ApproveInvoiceRequest {
  invoiceIds?: any[];
}

export interface ApproveApiResponseData {
  processedIds: number[];
  unProcessed:
    | {
        id: number;
        errorMessage: string;
      }[]
    | [];
}

const useApproveInvoiceApi = () => {
  const call = useCallback(async (params?: ApproveInvoiceRequest | undefined) => {
    try {
      if (isEmpty(params?.invoiceIds)) {
        throw new Error('invoiceIds empty');
      }
      const res = await axiosInstance.post(api.approveInvoice, params?.invoiceIds || []);
      return res.data as ApproveApiResponseData;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute, status } = useAsync<ApproveApiResponseData, ApproveInvoiceRequest>(
    call,
    false
  );

  return { approveInvoice: execute, approveCallLoading: isLoading, status };
};

export default useApproveInvoiceApi;
